<footer class="footer">
  <div class="footer-container">
    <div class="footer-column">
      <h3 class="footer-title">Меню</h3>
      <ul class="footer-menu">
        <li><a (click)="scrollTo('team')">Услуги</a></li>
        <li><a (click)="scrollTo('services')">Специализации</a></li>
        <li><a (click)="scrollTo('projects')">Портфолио</a></li>
        <li><a (click)="scrollTo('questions')">Вопросы</a></li>
        <li><a (click)="scrollTo('contacts')">Контакты</a></li>
      </ul>
    </div>
    <div class="footer-column">
      <h3 class="footer-title">Режим работы</h3>
      <ul class="work-hours">
        <li>Пн-Сб: 10:00 - 20:00</li>
      </ul>
    </div>
    <div class="footer-column">
      <h3 class="footer-title">Контакты</h3>
      <div class="footer-contacts">
        <a href="tel:+79050262162" class="phone-link">+7 (905) 026 21 62</a>
        <p class="adress">г. Казань, ул. Академика Лаврентьева</p>
        <div class="social-icons">
          <a href="https://t.me/DemlerIT" target="_blank" class="social-link">
            <img
              src="/assets/icons/tg.svg"
              alt="телеграм"
              class="social-icon"
              width="40"
              height="40"
              loading="lazy"
            />
          </a>
          <a
            href="https://wa.me/79050262162"
            target="_blank"
            class="social-link"
          >
            <img
              src="/assets/icons/whatsup.svg"
              alt="ватсап"
              class="social-icon"
              width="40"
              height="40"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </div>
    <div class="footer-column">
      <div class="footer-logo">
        <img
          src="/assets/icons/logo.svg"
          alt="Логотип Зилант"
          class="logo-icon"
          width="94"
          height="133"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</footer>
